<div class="flex flex-col justify-between items-start">
  <div class="flex flex-row">
    <ng-container *ngrxLet="device.gatewaySerial | cascadeDevicesBadge as cascadeDevices">
      <ng-container *ngIf="shouldDisplayDeviceImage()">
        <!-- Cascade -->
        <div
          *ngIf="cascadeDevices.count; else defaultTile"
          [matBadge]="cascadeDevices.count"
          [matTooltip]="
            ('+INSTALLATION_DETAILS_HEADER.CASCADE_DEVICES' | translate) + cascadeDevices.names
          "
          class="device-img-wrapper margin-right"
        >
          <ng-container *ngIf="device.deviceImage || imageUri; else hideImage">
            <img data-at-img [src]="device.deviceImage || imageUri" class="device-img" />
          </ng-container>
          <ng-template #hideImage>
            <mat-icon class="hide-image">hide_image</mat-icon>
          </ng-template>
        </div>
        <!-- Default -->
        <ng-template #defaultTile>
          <div class="device-img-wrapper">
            <ng-container *ngIf="device.deviceImage || imageUri; else hideImage">
              <img data-at-img [src]="device.deviceImage || imageUri" class="device-img" />
            </ng-container>
            <ng-template #hideImage>
              <mat-icon class="hide-image">hide_image</mat-icon>
            </ng-template>
          </div>
        </ng-template>
      </ng-container>
    </ng-container>
    <div class="flex flex-col justify-center items-start">
      <div class="device-name-container flex flex-row gap-[8px] justify-start items-center">
        <div data-at-title class="device-name flex flex-row gap-[8px] justify-start items-center">
          <span>{{ deviceName }}</span>
          <img *ngIf="brandLogo" class="mt-[-2px]" src="{{ brandLogo }}" />
        </div>
      </div>
      <div class="serial-container flex flex-row gap-[4px] justify-start items-center">
        <div data-at-boiler-serial class="serial">
          {{ serial ?? NO_VALUE }}
        </div>
        <ng-container *ngIf="gatewayHasDevices">
          <mat-icon
            data-at-edit-btn
            class="edit-boiler-serial-icon"
            *ngIf="installationDetailsStore.isEditBoilerSerialIconVisible(device) | async"
            mat-icon-button
            gtm="onEditBtn"
            gtmAction="Boiler serial"
            gtmCategory="deviceCard"
            color="primary"
            (click)="openBoilerSerialModal(device.boilerSerial)"
          >
            edit
          </mat-icon>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="flex gap-[4px] items-end">
    <app-aggregated-status-pill [gatewaySerial]="device.gatewaySerial"></app-aggregated-status-pill>
    <ng-container
      *ngIf="
        (isPermanentInspectionEntriesVisible$ | async) &&
        (isPermanentInspectionMenuItemVisible$ | async)
      "
    >
      <app-pill *ngIf="anomalyListForDevice$ | async; else noAnomalies" [type]="anomalyPillType">
        {{ '+REMOTE_INSPECTION.DASHBOARD_ANOMALY_DETECTED' | translate }}
      </app-pill>
      <ng-template #noAnomalies>
        <app-pill [type]="PillType.successInverted">
          {{ '+REMOTE_INSPECTION.DASHBOARD_NO_ANOMALY' | translate }}
        </app-pill>
      </ng-template>
    </ng-container>
  </div>
</div>
